import { useMemo } from 'react';
import useSWR from 'swr';
import LayerSwapApiClient from '../lib/apiClients/layerSwapApiClient';
import { buildQuoteUrl, validDestinationAddress } from './useFee';
const apiClient = new LayerSwapApiClient();
export function useAutoSlippageTest({ values, shouldTest }) {
    const validatedDestinationAddress = useMemo(() => validDestinationAddress(values.destination_address, values.to), [values.destination_address, values.to]);
    const autoSlippageTestURL = shouldTest
        ? buildQuoteUrl({
            sourceNetwork: values.from?.name ?? '',
            sourceToken: values.fromAsset?.symbol ?? '',
            destinationNetwork: values.to?.name ?? '',
            destinationToken: values.toAsset?.symbol ?? '',
            amount: values.amount ?? '',
            refuel: !!values.refuel,
            useDepositAddress: values.depositMethod !== 'wallet',
            destinationAddress: validatedDestinationAddress,
        })
        : null;
    const { data, isLoading, error } = useSWR(autoSlippageTestURL, apiClient.fetcher, {
        dedupingInterval: 10000,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        shouldRetryOnError: false,
        errorRetryCount: 0,
        onError: (err) => {
            console.debug('Auto slippage test failed:', err);
        }
    });
    return {
        autoSlippageWouldWork: !error && !!data?.data,
        isTestingAutoSlippage: isLoading,
    };
}
